import { Component, Input, OnInit,ViewEncapsulation } from '@angular/core';
import { FormControl, FormControlName } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-advance-input',
  templateUrl: './advance-input.component.html',
  styleUrls: ['./advance-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvanceInputComponent implements OnInit {

  @Input() control: FormControlName;
  @Input() dataList = [
    {'id': 1, 'name': 'One'},
    {'id': 2, 'name': 'Two'},
    {'id': 3, 'name': 'Three'},
    {'id': 4, 'name': 'Four'}
  ]
  inputValue = '';
  filteredData = [];
  showDropdown = false;
  // selectedItems: { id: number; name: string }[] = [];
  sample_data = this.sanitizer.bypassSecurityTrustHtml('<span style="color:#4CAF50"><b>$$</b>One</span>')
  // sample_data = this.sanitizer.bypassSecurityTrustHtml('<div style="color:#ff0000">One</div>')

  constructor(
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  onInput(event: any) {
    console.log(event)
    const value = event.target.innerText;
    console.log(value)
    console.log(this.sanitizer.bypassSecurityTrustHtml(event.target.innerText))
    this.inputValue = value;

    const regex = /\$\$([a-zA-Z]*)/;
    const match = value.match(regex);

    if (match && match[1]) {
      const searchString = match[1].toLowerCase();
      this.filteredData = this.dataList.filter(item =>
        item.name.toLowerCase().includes(searchString)
      );
      this.showDropdown = true;
    } else {
      this.showDropdown = false;
    }
  }

  selectItem(item: { id: number; name: string }) {
    // if (!this.selectedItems.find(selected => selected.id === item.id)) {
    //   this.selectedItems.push(item);
    // }
    this.inputValue = '';
    this.showDropdown = false;
    // inputElement.focus();
  }

  // removeItem(item: { id: number; name: string }) {
  //   this.selectedItems = this.selectedItems.filter(selected => selected.id !== item.id);
  // }
}
